<template>
    <div class="video-item" :class="{
        isloading: isLoading,
    }" @mouseenter="enterTrailer" @mouseleave="leaveTrailer" v-if="data">
        <div class="desktop-v">
            <div class="inner-video-item" :class="{ showmetapopup: showPopup }">
                <router-link class="thumbnail" :to="'/video/' + data.slug">
                    <img v-if="data.overviewImageUrl" :src="data.overviewImageUrl" />
                    <img v-else-if="!data.overviewImageUrl && mediaDetailsObj" :src="getVixyThumbnailUrl()" />
                    <ul class="labels" v-if="data.fields">
                        <li v-if="data.fields.day &&
                            data.fields.day.length > 0
                            ">

                            <span v-for="(item) in data.fields.day" :key="item.value">
                                {{ getEnumVal(item.value) }}
                            </span>

                        </li>
                        <li v-if="data.fields.typeofsession &&
                            data.fields.typeofsession.length > 0
                            ">

                            <span v-for="(item) in data.fields.typeofsession" :key="item.value">
                                {{ getEnumVal(item.value) }}
                            </span>

                        </li>
                    </ul>
                    <div class="mini-player-with-meta">
                        <router-link class="click-overlay" :to="'/video/' + data.slug"></router-link>
                        <div class="small-preview">
                            <div v-if="isAuthenticated && shortData" :id="'overview-' + data.mediaId"
                                style="position: absolute; width: 100%; height: 100%"></div>

                            <transition name="vid-fade">
                                <div class="thumbnail" v-if="!videoStarted">
                                    <img v-if="data.overviewImageUrl" :src="data.overviewImageUrl" />
                                    <img v-else-if="!data.overviewImageUrl &&
                                        mediaDetailsObj
                                        " :src="getVixyThumbnailUrl()" />
                                </div>
                            </transition>

                            <transition name="vid-fade">
                                <div class="show-reel-wrapper" v-if="isAuthenticated && !shortData && mediaDetailsObj">
                                    <!-- <span class="show-reel desktop" :style="{
                                    backgroundImage:
                                        'url(' + getVixyReel('430') + ')'
                                }"></span> -->
                                    <span class="show-reel big-desktop" :style="{
                                        backgroundImage:
                                            'url(' + getVixyReel('600') + ')'

                                    }"></span>
                                    <!-- <span class="show-reel small" :style="{
                                    backgroundImage:
                                        'url(' + getVixyReel('385') + ')'
                                }"></span> -->
                                </div>
                            </transition>
                        </div>
                        <div class="content-wrapper">
                            <div class="top-bar">
                                <router-link class="mini-btn play" :to="'/video/' + data.slug + '?play=true'"></router-link>
                                <!-- <button type="button" class="mini-btn add-to-users-list"></button> -->
                                <router-link class="mini-btn info" :to="'/video/' + data.slug"></router-link>
                            </div>

                            <div class="video-meta">
                                <h2 class="video-title" v-if="data.title">
                                    {{ data.title }}
                                </h2>
                                <span class="video-subtitle" v-if="data.subtitle">
                                    {{ data.subtitle }}
                                </span>
                                <div class="duration" v-if="mediaDetailsObj">
                                    {{ formatToClockDuration(mediaDetailsObj.msDuration) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </router-link>

                <div class="video-meta regular">
                    <h3 class="video-title" v-if="data.title">
                        {{ reformatDesktopTitle(data.title) }}
                    </h3>
                    <h3 class="video-subtitle" v-if="data.subtitle">
                        {{ reformatDesktopTitle(data.subtitle) }}
                    </h3>
                    <div class="duration" v-if="mediaDetailsObj">
                        {{ formatToClockDuration(mediaDetailsObj.msDuration) }}
                    </div>
                </div>
            </div>
        </div>
        <router-link class="mobile-v" :to="'/video/' + data.slug + '?play=true'">
            <div class="inner-video-item" :class="{ showmetapopup: showPopup }">
                <div class="thumbnail">
                    <span v-if="metaFields.genre.length > 0 &&
                        metaFields.genre.includes('Dalton+')
                        " class="special-genre-label">Dalton+</span>
                    <img v-if="data.overviewImageUrl" :src="data.overviewImageUrl" />
                    <img v-else-if="!data.overviewImageUrl && mediaDetailsObj" :src="getVixyThumbnailUrl()" />
                </div>

                <div class="video-meta regular">
                    <h3 class="video-title" v-if="data.title">
                        {{ reformatMobileTitle(data.title) }}
                    </h3>
                    <span class="video-subtitle" v-if="data.subtitle">
                        {{ reformatMobileTitle(data.subtitle) }}
                    </span>
                    <div class="duration" v-if="mediaDetailsObj">
                        {{ formatToClockDuration(mediaDetailsObj.msDuration) }}
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
//import { fetchMediaDetails } from "@streampac.io/chef_sp_1";

import {
    fetchVideoAsset,
    fetchVideoContentVideoType,
} from "@streampac.io/chef_sp_1";

const { kWidget } = window;

export default {
    inject: ["isAuthenticated"],
    props: {
        observer: null,
        doCalcOverlayPosition: {
            type: Boolean,
            default: () => { },
        },
        data: {
            type: Object,
            default: () => { },
        },
    },
    components: {
    },
    data() {
        return {
            isLoading: true,
            mediaDetailsObj: null,
            shortData: null,
            showTrailer: false,
            showPopup: false,
            timeOutID: null,
            vidWidget: null,
            dataIsSet: null,
            videoStarted: false,
            alignLeft: false,
            alignRight: false,
            //calcOverlayPosition: false,
            metaFields: {
                genre: [],
                kijkwijzer: [],
                year: "",
            },
        };
    },
    mounted() {
        // setTimeout(() => {
        // 	this.initPlayer();
        // }, 100);

        if (this.observer !== null && this.observer !== undefined) {
            this.observer.observe(this.$el);
        }

        this.setOverlayPosition();

        this.fetchDetails();
    },
    watch: {
        doCalcOverlayPosition(newVal) {
            if (newVal) {
                this.setOverlayPosition();
            }
        },
    },
    methods: {
        fetchDetails() {
            //this.transformDataValues();

            //Fetch video asset data
            fetchVideoAsset(this.isAuthenticated, this.data.mediaId).then(
                (response) => {
                    this.mediaDetailsObj = response;

                    //some extra time to display item. This way it has all the content loaded before displaying.
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 200);
                }
            );
        },
        reformatDesktopTitle(title) {
            let adjustedTitle = title;

            // if (title.length > 22) {
            //     adjustedTitle = title.substring(0, 22) + "..";
            // }

            return adjustedTitle;
        },
        reformatMobileTitle(title) {
            let adjustedTitle = title;

            if (title.length > 38) {
                adjustedTitle = title.substring(0, 34) + "..";
            }

            return adjustedTitle;
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, 0);
        },
        formatToClockDuration(milliseconds) {
            let seconds = Math.floor(milliseconds / 1000);
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);

            seconds = seconds % 60;

            minutes = seconds >= 30 ? minutes + 1 : minutes;

            minutes = minutes % 60;

            hours = hours % 24;

            if (hours > 0) {
                return `${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}:${this.padTo2Digits(seconds)}`;
            } else {
                return `${this.padTo2Digits(minutes)}:${this.padTo2Digits(seconds)}`;
            }
        },
        enterTrailer() {
            if (!this.dataIsSet || this.dataIsSet == null) {
                if (this.data.mediaShortId && this.data.mediaShortId !== "") {
                    fetchVideoContentVideoType(
                        this.isAuthenticated,
                        this.data.id,
                        "short?validSeconds=1000"
                    ).then((response) => {
                        this.shortData = response;
                        this.dataIsSet = true;
                    });
                } else if (this.data) {
                    this.dataIsSet = true;
                }
            }

            this.timeOutID = setTimeout(() => {
                //Fetch short
                this.showPopup = true;
            }, 200);

            this.timeOutID = setTimeout(() => {
                //Fetch short
                //this.activatePlayer();
            }, 700);
        },
        leaveTrailer() {
            this.showPopup = false;

            if (this.videoStarted) {
                const kdp = document.getElementById(
                    "overview-" + this.data.mediaId
                );
                kdp.sendNotification("doStop");
            }

            this.videoStarted = false;

            clearTimeout(this.timeOutID);
        },
        activatePlayer() {
            // console.log("activate player");
            // console.log(this.data);
            if (this.shortData && this.shortData.kalturaSession !== "") {
                // console.log("short stuff");
                kWidget.embed({
                    targetId: "overview-" + this.data.mediaId,
                    wid: "_391",
                    uiconf_id: 23452148,
                    flashvars: {
                        ks: this.shortData.kalturaSession,
                        playlistAPI: {
                            loop: true,
                            autoPlay: true,
                        },
                        //Remove controls
                        "controlBarContainer.plugin": false,
                        "largePlayBtn.plugin": false,
                        "loadingSpinner.plugin": true,
                    },
                    entry_id: this.data.mediaShortId,
                    readyCallback: () => {
                        this.videoStarted = true;
                    },
                });
            } else if (this.data && this.data.kalturaSession) {
                // console.log("regular stuff");
                kWidget.embed({
                    targetId: "overview-" + this.data.mediaId,
                    wid: "_391",
                    uiconf_id: 23452148,
                    flashvars: {
                        ks: this.data.kalturaSession,
                        mediaProxy: {
                            mediaPlayFrom: 30,
                            //mediaPlayTo: 40,
                        },
                        playlistAPI: {
                            loop: true,
                            autoPlay: true,
                        },
                        //Remove controls
                        "controlBarContainer.plugin": false,
                        "largePlayBtn.plugin": false,
                        "loadingSpinner.plugin": true,
                    },
                    entry_id: this.data.mediaId,
                    readyCallback: () => {
                        this.videoStarted = true;
                    },
                });
            }
        },
        getEnumVal(val) {
            const enums = this.$store.state.getEnumLookup;

            if (enums && enums.length > 0) {
                const enumFilter = enums.filter((item) => item.id === val);

                if (enumFilter && enumFilter.length > 0) {
                    return enumFilter[0].enumValue;
                }
            }

            return "";
        },
        getVixyThumbnailUrl() {
            if (this.mediaDetailsObj && this.mediaDetailsObj !== "") {
                const originalStr = this.mediaDetailsObj.thumbnailUrl;

                //const newStr = originalStr.replace("/width/200", "/width/600");
                const newStr = originalStr.replace(
                    "/width/200",
                    "/width/640/height/360/type/4/"
                );

                return newStr;
            }
        },
        getVixyReel(vixyReelSlideWidth) {
            if (this.mediaDetailsObj && this.mediaDetailsObj !== "") {
                const originalStr = this.mediaDetailsObj.thumbnailUrl;

                const newStr = originalStr.replace(
                    "/width/200",
                    "/width/" + vixyReelSlideWidth + "/vid_slices/20"

                );

                return newStr;
            }
        },
        setOverlayPosition() {
            // this.alignLeft = false;
            // this.alignRight = false;

            setTimeout(() => {
                const thisParentEL = this.$el;

                thisParentEL.classList.remove("align-left");
                thisParentEL.classList.remove("align-right");

                const parentRect = thisParentEL.getBoundingClientRect();

                //255 is half the width of the popup
                if (parentRect.left - 255 < 0) {
                    //this.alignLeft = true;
                    thisParentEL.classList.add("align-left");
                    thisParentEL.classList.remove("align-right");
                } else if (parentRect.right + 255 > window.innerWidth) {
                    //this.alignRight = true;
                    thisParentEL.classList.remove("align-left");
                    thisParentEL.classList.add("align-right");
                }
            }, 500);
        },
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>
